import React from "react";
import Chart from "react-apexcharts";

// 🔒 Utilities
const safeLabels = (arr) =>
  Array.isArray(arr) ? arr.map((x) => String(x ?? "Unknown")) : [];
const safeNumbers = (arr) =>
  Array.isArray(arr) ? arr.map((x) => Number(x) || 0) : [];

// const PieChart = ({
//   title = "",
//   labels = [],
//   series = [],
//   colors = [],
//   exportEnabled = true,
//   headerContent = null,
// }) => {
//   const options = {
//     chart: {
//       type: "donut",
//       toolbar: {
//         show: false,
//         tools: { download: exportEnabled },
//       },
//       animations: {
//         enabled: true,
//         easing: "easeinout",
//         speed: 1200,
//         animateGradually: { enabled: true, delay: 200 },
//         dynamicAnimation: { enabled: true, speed: 1000 },
//       },
//     },
//     plotOptions: {
//       pie: {
//         expandOnClick: false,
//         startAngle: 0,
//         endAngle: 360,
//       },
//     },
//     labels: safeLabels(labels), // ✅ always strings
//     colors,
//     legend: { position: "bottom" },
//     dataLabels: {
//       enabled: false,
//       formatter: (val) => `${isNaN(val) ? "0.0" : val.toFixed(1)}%`,
//     },
//     title: {
//       text: typeof title === "string" ? title : "",
//       align: "left",
//       style: { fontSize: "16px", fontWeight: "bold" },
//     },
//   };

//   return (
//     <div>
//       {headerContent && <>{headerContent}</>}
//       <Chart
//         options={options}
//         series={safeNumbers(series)} // ✅ always numbers
//         type="donut"
//         // height={headerContent ?365 : 390}
//         height={headerContent ?415 : 440}
//         key={safeNumbers(series).join("-")} // ✅ forces re-render safely
//       />
//     </div>
//   );
// };
const PieChart = ({
  title = "",
  labels = [],
  series = [],
  colors = [],
  exportEnabled = true,
  headerContent = null,
}) => {
  const options = {
    chart: {
      type: "donut",
      toolbar: { show: false },
      animations: {
        enabled: true,
        easing: "easeinout",
        speed: 1000,
      },
    },
    tooltip: {
      y: {
        formatter: (val) => `${val}%`,
      },
    },
    plotOptions: {
      pie: {
        expandOnClick: false,
        dataLabels: {
          offset: -2, // ✅ keep % inside
        },
        donut: {
          size: "70%",
          labels: {
            show: true,
            value: {
              formatter: (val) => `${val}%`,
            },
            total: {
              show: false,
              label: "Total",
              fontSize: "10px",
            },
          },
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => `${val.toFixed(1)}%`,
      style: { fontSize: "9px" },
    },
    labels: safeLabels(labels),
    colors,
    legend: {
      position: "bottom",
      horizontalAlign: "center",
    },
    title: {
      text: title,
      align: "left",
      style: { fontSize: "16px", fontWeight: "bold" },
    },
  };

  return (
    <div style={{ width: "100%", minHeight: headerContent ? 415 : 440 }}>
      {headerContent && <>{headerContent}</>}
      <Chart
        options={options}
        series={safeNumbers(series)}
        type="donut"
        height="100%"
        key={safeNumbers(series).join("-")}
      />
    </div>
  );
};

export default PieChart;
